/** ShapeSwap — replace your gesture with a shape already on the canvas, fitted to it. */
import type { AffectModule } from '../../core/module-api';
import { cloneShape, cloneStyle } from '../../core/scene';
import { bbox, transformPath } from '../../core/geometry';

const ICON =
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h13l-3-3"/><path d="M20 17H7l3 3"/></svg>';

export function createShapeSwap(): AffectModule {
  return {
    manifest: {
      id: 'shapeswap',
      kind: 'affect',
      name: 'Swap',
      apiVersion: 1,
      description: 'Trade your gesture for a shape already on the canvas, scaled to fit.',
      icon: ICON,
      capabilities: ['random'],
    },

    affect(shapes, ctx) {
      const pool = ctx.scene.shapes;
      if (pool.length === 0) return shapes.slice();
      return shapes.map((s) => {
        const src = pool[ctx.rng.int(0, pool.length - 1)];
        const sb = bbox(s.path);
        const db = bbox(src.path);
        const scale = Math.min(Math.max(1, sb.maxX - sb.minX) / Math.max(1, db.maxX - db.minX), Math.max(1, sb.maxY - sb.minY) / Math.max(1, db.maxY - db.minY));
        const dcx = (db.minX + db.maxX) / 2;
        const dcy = (db.minY + db.maxY) / 2;
        const scx = (sb.minX + sb.maxX) / 2;
        const scy = (sb.minY + sb.maxY) / 2;
        const c = cloneShape(src);
        c.path = transformPath(src.path, (p) => ({ x: scx + (p.x - dcx) * scale, y: scy + (p.y - dcy) * scale }));
        c.style = cloneStyle(s.style); // wear the current ink/weight
        c.gradient = undefined;
        c.variableWidth = undefined;
        return c;
      });
    },
  };
}
